<router-outlet *ngIf="ViewReady"></router-outlet>